/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function FlowerLotus(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M128,200c16,0,42.45589-.1803,72.88973-17.75129s40.28225-39.5825,43.43363-50.85144a7.95859,7.95859,0,0,0-5.67818-9.83489c-7.38178-1.89206-20.12947-3.60238-36.52927.288"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M53.88184,121.84985c-16.39872-3.88969-29.14558-2.17944-36.527-.28747a7.95859,7.95859,0,0,0-5.67818,9.83489c3.15138,11.26894,12.99979,33.28046,43.43363,50.85144S112,200,128,200"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M128,200s40-21.81818,40-80c0-45.58443-24.55378-68.84723-35.18644-76.78386a8.03282,8.03282,0,0,0-9.62712,0C112.55378,51.15277,88,74.41557,88,120,88,178.18182,128,200,128,200Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M128,200c11.99027-2.55021,44.33-20.78184,63.71281-54.35383S206.32158,85.26679,202.535,73.60781a7.99178,7.99178,0,0,0-9.27184-5.3531,77.437,77.437,0,0,0-31.35645,15.135"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M94.09282,83.38935a77.43686,77.43686,0,0,0-31.356-15.13464,7.99178,7.99178,0,0,0-9.27184,5.3531c-3.78659,11.659-8.56062,38.46637,10.82218,72.03836S116.00973,197.44979,128,200"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default FlowerLotus;
